/** Facility Network page tokens aligned with Figma nodes 8122:61085, 8410:61490 */

export const FN = {

  fontFamily: '"Rethink Sans", sans-serif',

  pageBg: "#fdffff",

  /** Outer card border — same as My Facility ContentContainer */

  shellBorder: "#99d4e1",

  shellMinHeight: "98vh",

  shellInsetShadow: "inset 8px 2px 58.4px 0px rgba(191,242,255,0.2)",

  /** Figma MC-Spaces inset — 7900:64833 */
  shellPaddingTop: { xs: 2, md: "42px" },
  shellPaddingLeft: { xs: 2, md: "42px" },
  shellPaddingRight: { xs: 2, md: "42px" },

  topBarBg: "#fcfcfc",

  topBarBorder: "#ccf5ff",

  activeTabBorder: "#065b70",

  tabBarBorder: "#35d7e4",

  roleCardBg: "rgba(228, 251, 255, 0.5)",

  roleCardBorder: "#1db0d2",

  roleCardLabel: "#475467",

  hierarchyPanelBorder: "#9ee5f4",

  infoBannerBg: "#fff8e6",

  infoBannerBorder: "#f5d90a",

  infoBannerText: "#8b4409",

  title: "#033843",

  pressed: "#065b70",

  primary: "#0a829d",

  muted: "#737373",

  text: "#262626",

  subtext: "#424242",

  metricCardBg: "#e5f5f8",

  metricCardBorder: "#35d7e4",

  panelBorder: "#bfe5ec",

  panelMutedBorder: "#e5f5f8",

  listItemBg: "#f3fdff",

  badgeBg: "#f3f9fa",

  chipTypeBg: "#5bbfd6",

  errorBg: "#fde7e9",

  errorBorder: "#e7a3a7",

  errorText: "#d13438",

  countBadgeBg: "#e5e5e5",

  /** Compact selected-facility top bar — aligned field height */
  headerFieldHeight: 40,
  headerFieldMinHeight: 40,
  headerFieldPy: 0,

  headerFieldPx: 1.5,

  /** Page chrome */

  pageTitleSize: 22,

  pageTitleIconSize: 26,

  pageTitleBadgeSize: 12,

  sectionGap: 1.5,

  panelPadding: 1,

  panelMinHeight: 280,

  tabMinHeight: 32,

  tabFontSize: 13,

  sectionTitleSize: 14,

  sectionSubtitleSize: 12,

  breadcrumbItemGap: 1.25,

  roleCardHeight: 80,

  roleCardHeightCompact: 64,

  roleCardValueSize: 18,

  roleCardLabelSize: 12,

  roleCardRowGap: 2.75,

  metricCardMinHeight: 100,

  metricValueSize: 24,

  chartPlaceholderHeight: 140,

  /** Vertical rhythm: facility header → tabs → title → content */

  headerToTabs: 2,

  tabsVerticalPad: 0.75,

  tabsToTitle: 1.75,

  titleSeparatorPad: 1,

  titleBelowSeparator: 0.5,

  contentAreaTopPad: 0.5,

  hierarchyPanelMinHeight: 354,

  hierarchyEmptyBannerMaxWidthWide: 520,

  /** Figma 9086:67404 / 9417:77639 — parent overview + child network */

  figmaCardBorder: "#e5e5e5",

  figmaCardShadow: "1px 1px 2px rgba(98,102,104,0.05), -1px -1px 2px rgba(98,102,104,0.05)",

  figmaCardRadius: "4px",

  figmaTitleSize: 24,

  figmaTitleTracking: "-0.06px",

  figmaNeutral: "#323130",

  figmaAccent: "#605e5c",

  figmaSuccess: "#107c10",

  figmaWarning: "#ed6c02",

  figmaError: "#a4262c",

  figmaErrorStroke: "#e7a3a7",

  figmaShareIconBg: "#e6fafc",

} as const;


